import { render, staticRenderFns } from "./deny.vue?vue&type=template&id=34386829&"
import script from "./deny.vue?vue&type=script&lang=js&"
export * from "./deny.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./deny-i18n.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fweb%2Fsrc%2Fviews%2Ferror%2Fdeny.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports